export default __webpack_public_path__ + "static/aboutCompany-8a319b2b15c22ad6b7ef060cd06d453f.png";